<template>
  <div
    class="max-w-md bg-white dark:bg-stone-800 rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg flex flex-col">
    <div class="px-6 pt-6 pb-2 flex-grow">
      <h3 class="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-4">
        How to Use Spin the Names
      </h3>
      <div class="text-stone-700 dark:text-stone-300">
        <p class="mb-4">
          <strong>Three simple steps to random selection excitement:</strong>
        </p>
        <ol class="list-decimal ml-5 space-y-2 mb-5">
          <li><strong>Enter names</strong> - Type or paste your list of names in the text box</li>
          <li><strong>Customize</strong> - Click <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-300"><i
                class="fas fa-palette mr-1"></i>Customize</span> to personalize colors, sounds, and spin settings</li>
          <li><strong>Spin the wheel</strong> - Click the wheel and watch it spin to reveal your random winner!</li>
        </ol>
        <p>
          Save your wheels for later, share them with others, or create new ones in seconds. Our intuitive interface
          makes random selection a breeze for everyone!
        </p>
      </div>
    </div>
    <div class="h-1 bg-gradient-to-r from-primary-500 to-primary-300 flex-none"></div>
  </div>
</template>
